import React from 'react';

import Select from 'components/new_ui/Select';
import { useContext } from '../Context';

export default function Currency() {
  const { dispatch: dispatchPlans, actions: actionsPlans, state: statePlans } = useContext();

  const onSelected = (currency) => {
    actionsPlans.setCurrency(dispatchPlans, currency);
  };

  const currencies = [
    {
      value: 'USD',
      label: 'USD',
    },
    {
      value: 'CAD',
      label: 'CAD',
    },
    {
      value: 'GBP',
      label: 'GBP',
    },
    {
      value: 'CHF',
      label: 'CHF',
    },
  ];

  return (
    <div>
      <Select
        id="policy-currencies"
        placeholder="Choose Currency"
        options={currencies}
        isClearable={false}
        defaultValue={currencies.find((item) => item.value === statePlans.currency)}
        onChange={(selectedOption) => { onSelected(selectedOption ? selectedOption.value : null); }}
        menuPlacement="top"
      />

    </div>
  );
}
